import * as React from "react";
import { getProductBlockDisplayDetails } from "@grandvisionhq/fun-search";
import { useVariantSwitcher, ProductBlock } from "@grandvisionhq/lib-visuals";
import { useProductLink } from "@grandvisionhq/products";
import { useBloomreachSiteLogos } from "../../../../../../../../hooks/hooks/use-bloomreach-site-logos.js";
const ProductListingRowBlock = ({ listingProduct, selectedVariant }) => {
  const { reimbursable } = useBloomreachSiteLogos();
  const { activeSku, activeVariant, handleVariantChange, consolidatedVariants } = useVariantSwitcher({
    variants: [listingProduct.masterVariant, ...listingProduct.variants],
    initialSku: selectedVariant ?? listingProduct.masterVariant.sku
  });
  const link = useProductLink(listingProduct.slug, activeSku, listingProduct.productType);
  if (!activeVariant) {
    return null;
  }
  const frontImage = activeVariant.images?.[0];
  const angleImage = activeVariant.images?.[1];
  const displayDetails = getProductBlockDisplayDetails({
    product: listingProduct,
    variant: activeVariant
  });
  return /* @__PURE__ */ React.createElement(ProductBlock.Outer, null, /* @__PURE__ */ React.createElement(ProductBlock.Inner, null, /* @__PURE__ */ React.createElement(ProductBlock.Header, null, /* @__PURE__ */ React.createElement(
    ProductBlock.Header.Left,
    {
      tag: activeVariant.tag,
      isProductReimbursable: activeVariant.isInsuranceReimbursable,
      defaultReimbursableLogo: reimbursable
    }
  ), /* @__PURE__ */ React.createElement(ProductBlock.Header.Right, { sku: activeVariant.sku })), /* @__PURE__ */ React.createElement(ProductBlock.Details, { href: link }, /* @__PURE__ */ React.createElement(ProductBlock.Details.Heading, null, displayDetails.heading), /* @__PURE__ */ React.createElement(ProductBlock.Details.Caption, null, displayDetails.caption)), /* @__PURE__ */ React.createElement(
    ProductBlock.Images,
    {
      href: link,
      frontUrl: frontImage?.url || "",
      frontAlt: frontImage?.altTag,
      angleUrl: angleImage?.url
    }
  ), /* @__PURE__ */ React.createElement(
    ProductBlock.Pricing,
    {
      originalPrice: activeVariant.pricing.price.originalPrice,
      discountedPrice: activeVariant.pricing.price.discount?.price,
      discountLabel: activeVariant.pricing.price.discount?.description,
      discountValue: activeVariant.pricing.price.discount?.badge,
      bestPrice: activeVariant.pricing.bestPrice,
      pricePerUnit: activeVariant.pricing.pricePerUnit?.amount,
      currency: activeVariant.pricing.price.currencyCode,
      isCentAmount: activeVariant.pricing.price.isCentAmount
    }
  ), /* @__PURE__ */ React.createElement(ProductBlock.Footer, null, /* @__PURE__ */ React.createElement(
    ProductBlock.Footer.Variants,
    {
      variants: consolidatedVariants,
      activeSku,
      onVariantChange: handleVariantChange
    }
  ))));
};
export {
  ProductListingRowBlock
};
//# sourceMappingURL=ProductListingRowBlock.js.map
